export { ContactPage as default } from '@/components/pages/Contact'
